var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaudiRiyalBlk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46842 13.4024C9.25429 13.8981 9.11274 14.4359 9.05851 15L13.5901 13.9945C13.8042 13.4989 13.9457 12.9609 14 12.3969L9.46842 13.4024Z",
    fill: "#2D2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5901 10.9819C13.8042 10.4864 13.9458 9.94841 14 9.38435L10.47 10.168V8.66151L13.59 7.96941C13.8041 7.47388 13.9457 6.93589 13.9999 6.37183L10.4699 7.15486V1.73689C9.92905 2.05391 9.44868 2.4759 9.0582 2.97365V7.4682L7.64645 7.78143V1C7.10556 1.31691 6.62519 1.73901 6.2347 2.23677V8.09455L3.07592 8.79522C2.86178 9.29075 2.72012 9.82874 2.66579 10.3928L6.2347 9.60109V11.4983L2.40991 12.3467C2.19578 12.8423 2.05423 13.3802 2 13.9443L6.00349 13.0562C6.32939 12.9854 6.6095 12.7843 6.79161 12.5075L7.52582 11.3713C7.60204 11.2537 7.64645 11.1117 7.64645 10.9591V9.28786L9.0582 8.97462V11.9877L13.5901 10.9819Z",
    fill: "#2D2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaudiRiyalBlk);
export default __webpack_public_path__ + "static/media/SaudiRiyal-BLK.0724c870e8f0bc0e7db6c8c731778997.svg";
export { ForwardRef as ReactComponent };